import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/scroll";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="bg-white py-24 lg:py-36 border-t border-border">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center flex flex-col items-center">
      <Reveal>
        <h2 className="font-serif text-4xl sm:text-6xl text-forest leading-[1.02] tracking-tight max-w-3xl">
          Start Planning Your Home in <span className="italic text-brass">Woodlake Estates</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-6 font-sans text-base sm:text-lg text-muted-foreground max-w-xl">
          Explore the available homesites and find the property that best fits your plans.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <button
            data-testid="cta-view-lots-btn"
            onClick={() => scrollToId("lots")}
            className="bg-forest text-cream font-sans text-sm font-semibold tracking-wide px-8 py-4 rounded-sm transition-colors duration-300 hover:bg-[#1f3d31]"
          >
            View Available Lots
          </button>
          <button
            data-testid="cta-contact-us-btn"
            onClick={() => scrollToId("contact")}
            className="bg-brass text-forest font-sans text-sm font-semibold tracking-wide px-8 py-4 rounded-sm transition-colors duration-300 hover:bg-[#cbaa66]"
          >
            Contact Us Now
          </button>
        </div>
        <p data-testid="cta-contact-line" className="mt-8 font-sans text-sm text-muted-foreground">
          Call <a href="tel:5043296166" className="text-forest font-medium underline underline-offset-4 decoration-brass/60">504-329-6166</a> or
          email <a href="mailto:brandy4lsu@cox.net" className="text-forest font-medium underline underline-offset-4 decoration-brass/60">brandy4lsu@cox.net</a>.
        </p>
      </Reveal>
    </div>
  </section>
);
